export default {
    gender: 'Aanhef',
    firstname: 'Voornaam',
    infixname: 'Tussenv.',
    surname: 'Achternaam',
    zipcode: 'Postcode',
    house_num: 'Huisnr.',
    house_num_add: 'Toev.',
    emailaddress: 'E-mailadres',

    prize: 'Prijs',
    telephone: 'Telefoonnummer'
};



// WEBPACK FOOTER //
// ./src/app/config/labels.js